import type { FC, ReactNode } from "react";

type FadeInProps = {
  children: ReactNode;
  className?: string;
};

const FadeIn: FC<FadeInProps> = ({ children, className = "" }) => {
  return <div className={`fade-in ${className}`.trim()}>{children}</div>;
};

export default FadeIn;
